module.exports = __webpack_public_path__ + "static/tickets_no_sale-0c6f35c4e0b98a85fb54834aaf46f990.svg";